import { useEffect } from 'react';
import { useEventFeedStore } from '@/stores/event-feed.store';
import type { FeedContext } from '@/stores/event-feed.store';
import { useFeatureFlags } from '@/hooks/useFeatureFlags';
import { ALERT_FEED_TYPES } from './EventFeedPanel';

interface EventFeedProps {
    context: FeedContext;
    alternateContexts?: FeedContext[];
}

const EMPTY_ALTERNATE_CONTEXTS: FeedContext[] = [];

export function EventFeed({
    context,
    alternateContexts = EMPTY_ALTERNATE_CONTEXTS,
}: EventFeedProps) {
    const show = useEventFeedStore((state) => state.show);
    const hide = useEventFeedStore((state) => state.hide);
    const { alertsEnabled } = useFeatureFlags();
    const isAlertContext = ALERT_FEED_TYPES.includes(context.type);

    useEffect(() => {
        if (isAlertContext && !alertsEnabled) {
            hide();
            return;
        }
        show(context, alternateContexts);
    }, [context, alternateContexts, show, hide, isAlertContext, alertsEnabled]);

    useEffect(() => {
        return () => hide();
    }, [hide]);

    return null;
}
